import { useMutation } from '@zenbusiness/application-commons-graphql';
import { v4 as uuidv4 } from 'uuid';

import { useLogError } from '#client/hooks/useLogError';
import { CREATE_BANKING_CARD_FOR_INSTANT_FUNDING } from '#client/mutations';

import useConstBusinessEntityUuid from './useConstBusinessEntityUuid';

export default function useInstantBankingCard() {
  const { businessEntityUuid } = useConstBusinessEntityUuid();

  const [mutate, { loading, error, errors }] = useMutation(
    CREATE_BANKING_CARD_FOR_INSTANT_FUNDING,
    {
      noThrow: true
    }
  );

  useLogError(errors, error);

  const createBankingCardForInstantFunding = async () => {
    const idempotencyKey = uuidv4();

    const { error: createCardError, data } = await mutate({
      variables: {
        input: {
          businessEntityUuid,
          idempotencyKey
        }
      }
    });

    return { data, error: createCardError };
  };

  return {
    createBankingCardForInstantFunding,
    loading
  };
}
